import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NGXLogger } from 'ngx-logger';
import { Notif } from 'src/app/models/param';
import { UpdateComponent } from '../../gestionparametre/update/update.component';

@Component({
  selector: 'fury-delivery-cancel',
  templateUrl: './delivery-cancel.component.html',
  styleUrls: ['./delivery-cancel.component.scss']
})
export class DeliveryCancelComponent implements OnInit {

  
  updateForm: FormGroup;

  param: Notif;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UpdateComponent>
    , private logger: NGXLogger
  ) { }

  ngOnInit() {
    this.buildItem(this.data.payload);
  }

  buildItem(value: any) {
    this.param = value;
    this.updateForm = new FormGroup({
      commandreference: new FormControl(this.param.commandreference, [Validators.required]),
      remove_assignment_comment: new FormControl("", [Validators.required])

    });
  }


  submit() {

    this.dialogRef.close(this.updateForm.value);
  }


}
